import { alpha, Card, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';

export interface SelectableCardProps {
  selected?: boolean;
  height?: number;
  width?: number | string;
}

export const SelectableCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'height' && prop !== 'width',
})<SelectableCardProps>(({ selected = false, height = 120, width = 360 }) => {
  const theme = useTheme();
  const accent = theme.palette.accent.main;

  return {
    width,
    height,
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '12px',
    borderWidth: selected ? 2 : 1,
    borderStyle: 'solid',
    borderColor: selected ? accent : theme.palette.divider,
    cursor: 'pointer',
    backgroundImage: 'none',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    background: selected ? alpha(accent, 0.08) : theme.palette.background.paper,
    '&:hover': {
      borderColor: accent,
      transform: 'translateY(-2px)',
      backgroundColor: alpha(accent, 0.06),
      boxShadow: `0 10px 28px -12px ${alpha(accent, 0.5)}`,
    },
  };
});
